export default __webpack_public_path__ + "static/media/smtp.55702e76.svg";